import { useState, useCallback, useEffect } from 'react';

interface GradientLayoutProps {
  children: React.ReactNode;
}

const GradientLayout: React.FC<GradientLayoutProps> = ({ children }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  const handleMouseMove = useCallback((e: MouseEvent) => {
    const x = (e.clientX / window.innerWidth) * 100;
    const y = (e.clientY / window.innerHeight) * 100;
    setMousePosition({ x, y });
  }, []);

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handleMouseMove]);

  const gradientStyle = {
    background: `
      radial-gradient(800px at ${mousePosition.x}% ${mousePosition.y}%, rgba(29, 78, 216, 0.12), transparent 80%),
      radial-gradient(600px at ${100 - mousePosition.x}% ${mousePosition.y}%, rgba(14, 165, 233, 0.12), transparent 80%),
      radial-gradient(800px at ${mousePosition.x}% ${100 - mousePosition.y}%, rgba(6, 182, 212, 0.12), transparent 80%),
      linear-gradient(to bottom, rgb(240, 249, 255), rgb(255, 255, 255))
    `,
    transition: 'background 0.3s ease'
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={gradientStyle}>
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default GradientLayout; 